import styledFuncs from 'app/styles/styledFuncs';
import { TransientPick } from 'app/tools/general.types';
import React from 'react';
import styled, { css } from 'styled-components/macro';

type ContainerProps = TransientPick<Props, 'variant' | 'gridCols'>;
const Container = styled.div<ContainerProps>`
  display: grid;
  grid-auto-columns: ${p => p.$gridCols || '1fr'};
  grid-auto-flow: column;

  ${p =>
    p.$variant === 'gap'
      ? // Add a gap between the inputs
        css`
          > *:not(:last-child) {
            padding-right: ${styledFuncs.pad()};
          }
        `
      : // Make the inputs with no gap or rounded
        // corners between boxes
        css`
          > *:not(:first-child) {
            .MuiOutlinedInput-notchedOutline,
            .MuiOutlinedInput-input {
              border-bottom-left-radius: 0;
              border-top-left-radius: 0;
            }
          }
          > *:not(:last-child) {
            .MuiOutlinedInput-notchedOutline,
            .MuiOutlinedInput-input {
              border-bottom-right-radius: 0;
              border-top-right-radius: 0;
            }
            // NOTE: this prevents the dividing borders from being
            // too thick, by overlapping the borders by 1 pixel
            .MuiOutlinedInput-notchedOutline {
              margin-right: -1px;
            }
          }
          // Prioritise borders at the joins, based on input state
          .MuiInputBase-root.Mui-error {
            z-index: 1;
          }
          .MuiInputBase-root.Mui-focused {
            z-index: 2;
          }
        `}
`;

type Props = {
  children: React.ReactNode;
  variant: 'gap' | 'flush';
  gridCols?: string;
};
export default function MultiPartInputBox({
  children,
  variant,
  gridCols,
}: Props): JSX.Element {
  return (
    <Container $variant={variant} $gridCols={gridCols}>
      {children}
    </Container>
  );
}
